import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatDateTime2 } from './dateHelper';

/**
 * Generates a PDF report with dynamic columns and a grand total row.
 * @param {Array} data - The raw API response where data[0] is the header row.
 * @param {Object} filters - Selected UI filters for the header.
 * @param {Object} user - Current user details.
 * @param {Object} totalConfig - Object containing { columnIndices: [], values: [] } for totals.
 */
/*
export const generateInvoicePDF = (data, filters, user, subcountyName, totalConfig ) => {
    if (!data || data.length === 0) return;

    const doc = new jsPDF('l', 'mm', 'a4'); // Using landscape for dynamic data
    const now = new Date();

    // 1. Extract Dynamic Headers and Rows
    // Assuming data[0] is the header row from the procedure output
    const tableColumn = data[0]; 
    const tableRows = data.slice(1);

    // 2. Prepare Grand Total Row (if provided)
    if (totalConfig && totalConfig.columnIndices) {
        const totalRow = new Array(tableColumn.length).fill("");
        totalRow[1] = "GRAND TOTAL"; // Label in the second column
        
        totalConfig.columnIndices.forEach((colIndex, i) => {
            if (colIndex < totalRow.length) {
                totalRow[colIndex] = totalConfig.values[i];
            }
        });
        tableRows.push(totalRow);
    }

    // 3. Report Header
    doc.setFontSize(18);
    doc.setFont(undefined, 'bold');
    doc.text("EMBU COUNTY GOVERNMENT", 14, 15, { align: 'center' });
    doc.addImage("/CountyLogo1.png", 'PNG', 15, 10, 20, 20); // Add logo to the header
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.text("EMBU COUNTY REVENUE AUTHORITY (ECRA)", 14, 15, { align: 'center' });

    //contact info.
    //First Contact info
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text("P.O. Box 36-60100 Embu", 14, 20, { align: 'left' });
    doc.text("Tel.: 0718500767", 14, 35, { align: 'left' });
    doc.text("Location: Embu Town House", 14, 25, { align: 'left' });

    //second contact info
    doc.text("email: ecra@embu.go.ke", 14, 30, { align: 'right' });
    doc.text("website: www.embu.go.ke | Eservices: eservice.embu.go.ke", 14, 40, { align: 'right' });
    doc.text("| Eservices: eservice.embu.go.ke", 14, 40, { align: 'right' });
    
    // Report Title
    const reportTitle = `${subcountyName} : ${filters.revStream} INVOICE DATA REPORT`;
    const reportTitle2 = `INVOICES WITH STATUS: ${filters.paymentStatus.toUpperCase()}`;
    
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text(reportTitle, 14, 30, { align: 'center' });
    doc.text(`Financial Year: ${filters.financialYear}`, 14, 35, { align: 'center' });
    doc.setFontSize(11);
    doc.setFont(undefined, 'bolditalic');
    doc.text(reportTitle2, 14, 36, { align: 'center' });

    // Generation Info
    doc.setFontSize(8);
    doc.setFont(undefined, 'italic');
    doc.text(`Generated by: ${user.username} | on date: ${formatDateTime2(now.toISOString())}`, 14, 40, { align: 'center' });
    doc.setLineWidth(0.5);
    doc.line(14, 30, doc.internal.pageSize.width - 14, 30); // Horizontal line
    
    //console.log("Final tableRows:", tableRows);
    // 4. Generate Table
    autoTable(doc,{
        startY: 45,
        head: [tableColumn],
        body: tableRows,
        theme: 'striped',
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [30, 41, 59], textColor: [255, 255, 255] }, // Slate-800
        didParseCell: function (data) {
            if (data.row.raw && data.row.raw[1] === "GRAND TOTAL") {
                data.cell.styles.fontStyle = 'bold';
                data.cell.styles.fillColor =  [220, 230, 241];
                 data.cell.styles.fontSize = 9;
            }
        }
    });

    // 5. Disclaimer Footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(150);
        const footerText = "Disclaimer: Official County Government Document For Internal Use Only. Unauthorized access or alteration is prohibited.";
        doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.width - 20, doc.internal.pageSize.height - 10, { align: 'right' });
        doc.text(footerText, doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, { align: 'center' });
        
    }

    doc.save(`${filters.paymentStatus.toUpperCase()}_${filters.revStream.toUpperCase()}_INVOICES_${subcountyName}_${Math.floor(Date.now() / 1000)}.pdf`);
};
*/
/**
 * Generates a PDF report with dynamic columns and a grand total row.
 * @param {Array} data - The raw API response where data[0] is the header row.
 * @param {Object} filters - Selected UI filters for the header.
 * @param {Object} user - Current user details.
 * @param {Object} totalConfig - Object containing { columnIndices: [], values: [] } for totals.
 */
export const generateInvoicePDF = (data, filters, user, subcountyName, halfLabel, totalConfig) => {
    if (!data || data.length === 0) return;

    //const doc = new jsPDF('l', 'mm', 'a4');
    const doc = new jsPDF({
        orientation: 'l',
        unit: 'mm',
        format: 'a4',
        encryption: {
            userPassword: '', // Empty = no password for opening
            ownerPassword: 'your-secret-password-here', // Required for permissions
            userPermissions: ['print', 'copy'] // Restrict permissions
        }
    });

    // Add security restrictions
    doc.setProperties({
        title: `${filters.revStream} Invoice Report`,
        subject: 'Official Embu County Document',
        author: user.username,
        keywords: 'confidential, internal, county',
        creator: 'ICRMS System',
        producer: 'Revenue Performance management and Reporting Portal'
    });

    const pageWidth = doc.internal.pageSize.width;
    const now = new Date();

    // 1. Extract Dynamic Headers and Rows
    const tableColumn = data[0];
    const tableRows = data.slice(1);

    // 2. Prepare Grand Total Row (if provided)
    if (totalConfig && totalConfig.columnIndices) {
        const totalRow = new Array(tableColumn.length).fill("");
        totalRow[1] = "GRAND TOTAL";
        
        totalConfig.columnIndices.forEach((colIndex, i) => {
            if (colIndex < totalRow.length) {
                totalRow[colIndex] = totalConfig.values[i];
            }
        });
        tableRows.push(totalRow);
    }

    // 3. COMPACT HEADER SECTION - Reduced spacing
    const centerX = pageWidth / 2;
    let yPosition = 15; // Started higher on page

    // Top line
    //doc.setDrawColor(0, 0, 0);
    //doc.setLineWidth(0.3);
    //doc.line(14, yPosition - 3, pageWidth - 14, yPosition - 3);

    // Smaller logo (15x15 instead of 20x20)
    doc.addImage("/CountyLogo1.png", 'PNG', centerX - 7.5, yPosition - 5, 15, 15);

    // Compact header text - smaller fonts and closer together
    doc.setFontSize(14); // Reduced from 16
    doc.setFont(undefined, 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text("EMBU COUNTY GOVERNMENT", centerX, yPosition + 12, { align: 'center' });

    doc.setFontSize(12); // Reduced from 14
    doc.setTextColor(50, 50, 50);
    doc.text("EMBU COUNTY REVENUE AUTHORITY (ECRA)", centerX, yPosition + 20, { align: 'center' });

    // 4. Two-Column Contact Info - More compact
    doc.setFontSize(8); // Reduced from 9
    doc.setFont(undefined, 'bold');
    doc.setTextColor(80, 80, 80);

    // Left Column Contact Info
    const leftColX = 20;
    const rightColX = pageWidth - 65;
    const contactY = yPosition + 25; // Closer to header

    doc.text("P.O. Box 36-60100 Embu", leftColX, contactY);
    doc.text("Location: Embu Town House", leftColX, contactY + 4); // Reduced spacing
    doc.text("Tel.: 0718500767", leftColX, contactY + 8); // Reduced spacing

    // Right Column Contact Info
    doc.text("email: ecra@embu.go.ke", rightColX, contactY);
    doc.text("website: www.embu.go.ke", rightColX, contactY + 4);
    doc.text("eservice.embu.go.ke", rightColX, contactY + 8);

    // 5. Report Title Section - More compact
    const titleY = contactY + 15; // Closer to contact info
    
    // Decorative line - Blue
    doc.setDrawColor(0, 102, 204); // Blue
    doc.setLineWidth(0.2);
    doc.line(30, titleY - 3, pageWidth - 30, titleY - 3);

    // Main Title - Smaller font
    doc.setFontSize(14); // Reduced from 16
    doc.setFont(undefined, 'bold');
     doc.setTextColor(0, 51, 102); // Dark blue
    const reportTitle = `${subcountyName.toUpperCase()} : ${filters.revStream.toUpperCase()} INVOICE DATA REPORT`;
    doc.text(reportTitle, centerX, titleY + 3, { align: 'center' });

    // Financial Year - Smaller font, less spacing
    doc.setFontSize(10); // Reduced from 12
    doc.setFont(undefined, 'bold');
    doc.setTextColor(0, 102, 204); // Medium blue
    doc.text(`Financial Year: ${filters.financialYear} | [${halfLabel}]`, centerX, titleY + 8, { align: 'center' });

    // Status - Smaller font, less spacing
    doc.setFontSize(10); // Reduced from 11
    doc.setFont(undefined, 'bolditalic');
    if (filters.paymentStatus.toLowerCase() === 'paid') {
        doc.setTextColor(0, 153, 0); // Green for paid
    } else if (filters.paymentStatus.toLowerCase() === 'pending') {
        doc.setTextColor(204, 0, 0); // Red for pending
    } else {
         doc.setTextColor(0, 102, 204); // Blue for others
    }
    //doc.setTextColor(204, 0, 0); // Red
    const reportTitle2 = `Invoices with status: [${filters.paymentStatus.toUpperCase()}]`;
    doc.text(reportTitle2, centerX, titleY + 15, { align: 'center' });

    // Generation Info - Smaller font, less spacing
    doc.setFontSize(10); // Reduced from 8
    doc.setFont(undefined, 'bolditalic');
    doc.setTextColor(120, 120, 120);
    doc.text(`Generated by: ${user.username} `, leftColX, titleY + 16, { align: 'left' });

    doc.setFontSize(10); // Reduced from 8
    doc.setFont(undefined, 'bolditalic');
     doc.setTextColor(0, 102, 204); // Blue
    doc.text(`${formatDateTime2(now.toISOString())}`, rightColX, titleY + 16, { align: 'right' });

    // Bottom line - closer to content
      // Bottom line - Blue and Red combination
    doc.setDrawColor(0, 102, 204); // Blue
    doc.setLineWidth(0.3);
    doc.line(14, titleY + 20, pageWidth / 2 - 5, titleY + 20);
    
    doc.setDrawColor(204, 0, 0); // Red
    doc.line(pageWidth / 2 + 5, titleY + 20, pageWidth - 14, titleY + 20);

    // 6. Generate Table with improved styling
    autoTable(doc, {
        startY: titleY + 25,
        head: [tableColumn],
        body: tableRows,
        theme: 'striped',
        styles: {
            font: 'courier', // Monospaced font for better alignment
            fontSize: 8, 
            cellPadding: 1,
            lineColor: [200, 200, 200],
            lineWidth: 0.0
        },
        headStyles: { 
            fillColor: [30, 41, 59], 
            textColor: [255, 255, 255],
            fontStyle: 'bold',
            halign: 'center'
        },
        alternateRowStyles: {
            fillColor: [245, 247, 250]
        },
        columnStyles: {
            0: { halign: 'center' } // Center first column (usually row numbers)
        },
        didParseCell: function (data) {
            // Style for GRAND TOTAL row
            if (data.row.raw && data.row.raw[1] === "GRAND TOTAL") {
                data.cell.styles.fontStyle = 'bold';
                data.cell.styles.fillColor = [220, 230, 241];
                data.cell.styles.fontSize = 9;
                data.cell.styles.textColor = [0, 0, 0];
            }
            
            // Style for numeric columns (right align)
            if (typeof data.cell.raw === 'number' || 
                (typeof data.cell.raw === 'string' && /^[\d,]+(\.\d+)?$/.test(data.cell.raw))) {
                data.cell.styles.halign = 'right';
            }
        },
        didDrawPage: function (data) {
                        // Add copy protection watermark on every page
            doc.setGState(new doc.GState({ opacity: 0.15 }));
            doc.setFontSize(20);
            doc.setTextColor(100, 100, 100);
            
            // Add diagonal "CONFIDENTIAL" watermarks
            const pageWidth = doc.internal.pageSize.width;
            const pageHeight = doc.internal.pageSize.height;
            
            // Multiple watermarks for better protection
            for (let i = -1; i <= 1; i++) {
                for (let j = -1; j <= 1; j++) {
                    doc.text(
                        "*** ECG **** ECG **** ECG **** ECG ***",
                        pageWidth / 2 + (i * 30),
                        pageHeight / 2 + (j * 20),
                        { 
                            align: 'justify', 
                            angle: 45,
                            charSpace: 2
                        }
                    );
                }
            }
            
            // Reset opacity
            doc.setGState(new doc.GState({ opacity: 1 }));
            addSecurityNoise(doc);
            addSecurityBackground(doc);
           // doc.addSecurityNoise(); // Add random noise for extra protection
            //doc.addSecurityBackground(); // Add light background pattern to deter copying
            // Add footer on each page
            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                
                // Footer line
                doc.setDrawColor(180, 180, 180);
                doc.setLineWidth(0.2);
                doc.line(14, doc.internal.pageSize.height - 15, pageWidth - 14, doc.internal.pageSize.height - 15);
                
                // Footer text
                doc.setFontSize(7);
                doc.setTextColor(150, 150, 150);
                
                // Left footer - document info
                const footerLeft = "Official County Government Document";
                doc.text(footerLeft, 14, doc.internal.pageSize.height - 8);
                
                // Center footer - disclaimer
                const disclaimer = "For Internal Use Only. Unauthorized access or alteration is prohibited.";
                doc.text(disclaimer, centerX, doc.internal.pageSize.height - 8, { align: 'center' });
                
                // Right footer - page numbers
                doc.text(`Page ${i} of ${pageCount}`, pageWidth - 14, doc.internal.pageSize.height - 8, { align: 'right' });
                
                // Add watermark effect (very light)
                doc.setGState(new doc.GState({ opacity: 0.01 }));
                doc.setFontSize(40);
                doc.setTextColor(100, 100, 100);
                doc.text("ECRA", centerX, doc.internal.pageSize.height / 2, { 
                    align: 'center', 
                    angle: 45 
                });
                doc.setGState(new doc.GState({ opacity: 1 }));
            }
        }
        
    });

    // 7. Save the PDF with formatted filename
    const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
    const filename = `${filters.paymentStatus.toUpperCase()}_${filters.revStream.replace(/\s+/g, '_')}_INVOICES_${subcountyName.replace(/\s+/g, '_')}_${timestamp}.pdf`;
    doc.save(filename);
};
// Add random noise to the PDF (makes text extraction harder)
const addSecurityNoise = (doc) => {
    // Add micro dots at random positions (invisible to naked eye)
    doc.setGState(new doc.GState({ opacity: 0.01 }));
    doc.setDrawColor(255, 255, 255);
    
    for (let i = 0; i < 100; i++) {
        const x = Math.random() * doc.internal.pageSize.width;
        const y = Math.random() * doc.internal.pageSize.height;
        doc.circle(x, y, 0.1, 'F');
    }
    
    doc.setGState(new doc.GState({ opacity: 1 }));
};
// Add image-based security
const addSecurityBackground = (doc) => {
    // Create a subtle pattern background
    doc.setGState(new doc.GState({ opacity: 0.03 }));
    doc.setFontSize(4);
    doc.setTextColor(150, 150, 150);
    
    for (let y = 20; y < doc.internal.pageSize.height; y += 15) {
        doc.text("EMBU COUNTY • OFFICIAL • CONFIDENTIAL • ", 
            doc.internal.pageSize.width / 2, y, { align: 'center' });
    }
    
    doc.setGState(new doc.GState({ opacity: 1 }));
};